// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"d00d2142","247":"3809f53d","268":"39c98a17","551":"eb752340","627":"04c2f8f4","653":"d56af35b","834":"32ec360e","867":"ce94db77","923":"71fcd7a0","938":"e689c0d1"}[chunkId] + ".chunk.js";
};